export const isInternalLink = url => {
	const urlObj = new URL(url, rtwp.root);
	const rtwpObj = new URL(rtwp.root);
	return urlObj.host === rtwpObj.host;
};

export const getUrl = url => {
	const urlObj = new URL(url, rtwp.root);
	if (isInternalLink(url)) {
		return urlObj.pathname + urlObj.hash;
	}
	return url;
};

export default {
	isInternalLink,
	getUrl,
}

